import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const Container = styled.div`
  position: relative;
  box-sizing: border-box;
  width: 44px;
  height: 26px;
  min-width: 44px;
  min-height: 26px;

  ${props => props.active ?
    `background-color: ${props.color ? props.color : '#3DCD58'}; border: 1px solid ${props.color ? props.color : '#3DCD58'};`
    : `background-color: #FFFFFF; border: 1px solid #9FA0A4;` }

  border-radius: 13px;
  cursor: pointer;
  transition: background-color 0.2s, border 0.2s;
`;

const Bubble = styled.div`
  position: absolute;
  width: 24px;
  height: 24px;
  ${props => props.active ? `right: 0px;` : 'right: 18px; box-shadow: 0px 0px 8px rgba(98, 100, 105, 0.2);'}
  top: calc(50% - 24px/2);
  background: #FFFFFF;
  border-radius: 50%;
  transition: right 0.2s;
`;

class Toggle extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    active: PropTypes.bool,
    color: PropTypes.string,
    onToggle: PropTypes.func
  };

  render() {
    const idProps = {};
    if (this.props.id) {
      idProps['id'] = this.props.id + '-toggle';
    }

    return (
      <Container {...idProps} active={this.props.active} color={this.props.color} onClick={(event) => { event.stopPropagation(); this.props.onToggle(!this.props.active); }}>
        <Bubble active={this.props.active}></Bubble>
      </Container>
    );

  }
}

export default Toggle;
